import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { HookSection } from './components/HookSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { TransformationSection } from './components/TransformationSection';
import { PriceSection } from './components/PriceSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { SocialProofPopups } from './components/SocialProofPopups';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showSocialProof?: boolean;
}
export function App({
  showSocialProof = true
}: AppProps) {
  useMetaPixel();
  return <div className="w-full min-h-full bg-white font-sans text-gray-900" data-id="element-0" data-mp="23vkvuhy9gblr">
      <UrgencyBar data-id="element-1" data-mp="23t8h0dnsuhcx" />
      <main data-id="element-2" data-mp="3ijxsgzk2wgo4">
        <Hero data-id="element-3" data-mp="3ikh829m9asyz" />
        <HookSection data-id="element-4" data-mp="3iiwdijzxza14" />
        <TomosSection data-id="element-5" data-mp="3ijfv1zlojwem" />
        <BonusSection data-id="element-6" data-mp="3ihuyy5jpw5en" />
        <TransformationSection data-id="element-7" data-mp="3mlaxx8j9ehui" />
        <PriceSection data-id="element-8" data-mp="3mkhou0wtvg97" />
        <GuaranteeSection data-id="element-9" data-mp="3mjq2lgp4euvl" />
        <FaqSection data-id="element-10" data-mp="3rc9du70c5dx8" />
        <FinalCtaSection data-id="element-11" data-mp="3rbrbcsn2y3gv" />
      </main>
      <Footer data-id="element-12" data-mp="3rcswjpxt86cb" />
      {showSocialProof && <SocialProofPopups data-id="element-13" data-mp="5yjetptzbev" />}
    </div>;
}